var map = {
	"./IMG_3711.jpg": 4570,
	"./Kopia IMG_3707.jpg": 3765,
	"./Kopia IMG_3709.jpg": 6058,
	"./Kopia IMG_3710.jpg": 4227,
	"./Kopia IMG_3713.jpg": 9630,
	"./Kopia IMG_3717.jpg": 4553,
	"./Kopia IMG_3718.jpg": 3049
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8921;